import { render, staticRenderFns } from "./m-feature-item.vue?vue&type=template&id=69b22fa1&lang=pug"
import script from "./m-feature-item.vue?vue&type=script&lang=js"
export * from "./m-feature-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports